import { Fragment } from 'react';

import useClubRecognitionSearch from './UseClubRecognitionSearch';

import LscDropdown from '@usas/ui-web/components/dropdowns/lscDropdown/LscDropdown';
import OrgUnitCombobox from '@usas/ui-web/components/comboboxes/orgUnitCombobox/OrgUnitCombobox';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';

const CRPSearchForm = ({ formState, errorState, environmentVariableState, clearForm, handleSubmit, onValueTextPairChanged }) => (
  <form onSubmit={handleSubmit} noValidate>
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-4">
        <LscDropdown
          label="LSC"
          name="lscOrgUnitId"
          value={formState.lscOrgUnitId}
          error={errorState.lscOrgUnitId}
          message={errorState.lscOrgUnitId}
          onChange={(newValue, newValueLabel, e) => {
            onValueTextPairChanged(newValue, 'lscOrgUnitId', newValueLabel, 'lscName', e);
            onValueTextPairChanged('', 'orgUnitId', '', 'orgUnitName', e);
          }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <OrgUnitCombobox
          label="Club Name*"
          name="orgUnitName"
          valueToMatch={formState.orgUnitName}
          error={errorState.orgUnitId}
          message={errorState.orgUnitId}
          onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'orgUnitId', newValueLabel, 'orgUnitName', e); }}
          organizationId={formState.organizationId}
          lscId={formState.lscOrgUnitId} />
      </div>
    </div>
    <div className="row usas-extra-top-margin usas-extra-bottom-margin">
      <div className="col-xs-12 usas-extra-top-margin">
        <PrimaryButton type="submit">Go To CRP</PrimaryButton>&nbsp;
        <SecondaryButton type="button" onClick={() => clearForm()}>Clear Form</SecondaryButton>&nbsp;
      </div>
    </div>
  </form >
);

const ClubRecognitionSearch = () => {
  const {
    formState,
    errorState,
    environmentVariableState,
    clearForm,
    handleSubmit,
    onValueTextPairChanged,
  } = useClubRecognitionSearch();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>CRP Search</Headings.H3>
        </div>
      </div>
      <CRPSearchForm
        formState={formState}
        errorState={errorState}
        environmentVariableState={environmentVariableState}
        clearForm={clearForm}
        handleSubmit={handleSubmit}
        onValueTextPairChanged={onValueTextPairChanged} />
    </Fragment>
  );
};

export default ClubRecognitionSearch;